<template>
  <div class="w-100 release-main">
    <div class="pl-3">
      <h2 class="title-release">
        v{{ version }}
      </h2>
      <p class="date-release">
        {{ date }}
      </p>
      <h4 v-if="!only_bug_fix">
        Features
      </h4>
      <p v-if="!only_bug_fix">
        There are new features for djuli {{ version }}:
      </p>
      <slot>
        Powered by ZP
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Release',
  props:{
    version:{
      type:String,
      required:true
    },
    date:{
      type:String,
      required:true
    },
    only_bug_fix:{
      type:Boolean,
      required:false,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
.release-main{
  border: 2px solid #888;
  background-color: #FFF;
  border-radius: 15px;
  box-shadow: 0 8px 8px 0 #ccc;
  margin-top: 2rem !important;
  padding:1rem;
}
.title-release{
  color:#378a32;
  font-size:1.85rem;
  padding-bottom: 0.25rem;
}
.date-release{
  font-size: 0.8rem;
  color: #777;
}
h4{
  color: #3d9636;
  font-weight: bold;
  font-size: 1.1rem;
  margin-top: 0.5rem;
}
h2{
  font-weight: bold;
}
ul {
  list-style: none;
  padding-left: 1rem;
}
ul li:before {
  content: '✓  ';
}
</style>